/** CRM'e kaydedilen ürün seçicisinin metinleri (`SavedProductPicker.tsx`). */
export const KAYITLI_URUN = {
  openList: 'CRM ürünlerinden ekle',
  openNew: 'Yeni ürün oluştur',
  titleNew: 'Yeni CRM ürünü',
  titleList: 'Kayıtlı CRM ürünleri',
  introNew: 'Ürünü kaydedin ve bu teklife ekleyin. Sonraki tekliflerde de kullanabilirsiniz.',
  introList: (currency: string) => `Kayıtlı ürünlerinizin tümü gösterilir. Teklifiniz ${currency} cinsinden.`,
  close: 'Kapat',
  scope: 'Bu ürünler yalnız CRM’de kullanılır; web sitesinde yayımlanmaz.',
  search: 'Ürün ara',
  searchPlaceholder: 'Ürün adı veya açıklama',
  loading: 'Kayıtlı ürünler yükleniyor…',
  retry: 'Yeniden dene',
  noMatch: 'Aramanıza uygun ürün bulunamadı.',
  noneInCurrency: 'Kayıtlı ürün yok.',
  emptyHint: 'Yeni ürün oluşturarak CRM ürün listenize ekleyebilirsiniz.',
  tax: (rate: string) => `Vergi %${rate}`,
  addLabel: (name: string) => `${name} ürününü teklife ekle`,
  add: 'Ekle',
  createdBy: (name: string) => `Oluşturan: ${name}`,
  otherCurrency: (own: string, quote: string) => `${own}: teklif ${quote}`,
  mismatchAdded: (name: string, own: string, price: string, quote: string) => `${name} ${own} cinsinden kayıtlı (${price}). Teklifiniz ${quote}; fiyat dönüştürülmedi. Fiyatı ${quote} olarak elle girin.`,
  usdEquivalent: (usd: string, rate: string) => `USD karşılığı (yaklaşık): ${usd} (${rate})`,
  usdRateEur: (rate: string, date: string) => `kur 1 EUR = ${rate} USD, ${date}`,
  usdRateAed: (rate: string) => `sabit kur 1 USD = ${rate} AED`,
  edit: 'Düzenle',
  editLabel: (name: string) => `${name} ürününü düzenle`,
  titleEdit: 'CRM ürününü düzenle',
  introEdit: 'Değişiklik yalnız bu ürünü ve sonraki teklifleri etkiler. Eski tekliflerdeki kalemler değişmez.',
  currency: 'Para birimi',
  currencyChanged: (from: string, to: string) => `Para birimi ${from} iken ${to} oldu. Fiyat otomatik dönüştürülmez; ${to} cinsinden fiyatı yeniden girin.`,
  saveEdit: 'Değişiklikleri kaydet',
  editSaved: (name: string) => `${name} güncellendi.`,
  priceRetype: 'Para birimi değişti: fiyatı yeniden girin.',
  pagesLabel: 'Kayıtlı ürün sayfaları',
  pageRange: (from: number, to: number, total: number) => `${from}–${to} / ${total} ürün`,
  previous: 'Önceki',
  next: 'Sonraki',
  fields: 'Ürün bilgileri',
  name: 'Ürün adı',
  kind: 'Ürün türü',
  supplier: 'Tedarikçi',
  optional: '(isteğe bağlı)',
  unitPrice: (currency: string) => `Birim fiyat (${currency})`,
  pricePlaceholder: '125,00',
  currencyHint: (currency: string) => `Para birimi teklifinizden alınır: ${currency}.`,
  taxRate: 'Vergi (%)',
  taxPlaceholder: '5',
  taxHint: 'Örnek: 5 veya 5,50',
  description: 'Açıklama',
  descriptionHint: 'Ürün adı ve açıklama birlikte en fazla 200 karakter.',
  backToList: 'Kayıtlı ürünlere dön',
  saving: 'Kaydediliyor…',
  save: 'Kaydet ve teklife ekle',
  added: (name: string) => `${name} teklife eklendi.`,
  listTimeout: 'Ürünler zamanında yüklenemedi. Yeniden deneyin.',
  listFailed: 'Kayıtlı ürünler yüklenemedi.',
  nameOrPriceInvalid: 'Ürün adını ve geçerli bir birim fiyatı girin.',
  tooLong: 'Ürün adı ve açıklaması birlikte en fazla 200 karakter olabilir.',
  supplierTooLong: 'Tedarikçi adı en fazla 120 karakter olabilir.',
  taxInvalid: 'Vergi oranı %0 ile %100 arasında olmalı.',
  checkFields: 'Ürün bilgilerini kontrol edin.',
  saveFailed: 'Ürün kaydedilemedi. Bilgilerinizi kontrol edip yeniden deneyin.',
} as const;
